import React from 'react'
import { withOrders } from '../../hoc/withOrders'
import { withMostRecentOrder } from '../../hoc/withMostRecentOrder'
import { OrderCard } from '../OrderCard'

const EnhancedLastOrder = withOrders(withMostRecentOrder(OrderCard))

const LastOrder = () => <EnhancedLastOrder />

export { LastOrder }
